import React from 'react';
import './auth.css';

export default function SessionExpired({ onContinue }) {
  return (
    <div className="signal-auth-root" data-testid="session-expired-screen">
      <div className="signal-auth-bg" aria-hidden="true" />
      <div className="signal-auth-card">
        <div className="signal-auth-brand">
          <div className="signal-auth-mark signal-auth-mark-amber" />
          <div className="signal-auth-brand-text">
            <div className="signal-auth-logo">SESSION EXPIRED</div>
            <div className="signal-auth-tagline">RE-AUTHENTICATION REQUIRED</div>
          </div>
        </div>
        <div className="signal-auth-sub">
          Your secure session has ended. Sign in again to continue.
        </div>
        <button className="signal-auth-submit" onClick={onContinue} data-testid="session-expired-continue-btn">
          RETURN TO SIGN IN
        </button>
      </div>
    </div>
  );
}
